import configuration from "@utils/Config";
import { createEffect } from "effector";
import { restGetHandler, restUpdateHandler } from "@utils/rest/RestClient";
import { AlertSearchResponseDto } from "@state/alerts/dto/response/alert.search.response.dto";

const baseUrl = configuration.backendBaseUrl;
const alertsUrl = baseUrl + "/ws/fo/alert";
const vuUrl = "/vu";

export const requestSearchAlerts = createEffect({
  handler: restGetHandler<AlertSearchResponseDto>(alertsUrl),
});

export const requestUpdateAlertSeen = createEffect({
  handler: restUpdateHandler<boolean, AlertSearchResponseDto>(alertsUrl, vuUrl),
});
